import { render, staticRenderFns } from "./ISRtops.vue?vue&type=template&id=37de08e8&"
import script from "./ISRtops.vue?vue&type=script&lang=js&"
export * from "./ISRtops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports